/* global Swiper */
// *******************************************************************************
// Article slider
// *******************************************************************************

const articleSlider = document.querySelectorAll('[data-slider="article-slider__init"]');

const articleSliderOption = {
  slidesPerView: 'auto',
  spaceBetween: 12,
  loop: false,
  speed: 600,
  breakpoints: {
    576: {
      spaceBetween: 18,
    }
  },
};

articleSlider.forEach((el) => {
  // eslint-disable-next-line no-new
  new Swiper(el, articleSliderOption);
});
